<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 5">
    <path d="m0 0 5 5 5-5" fill="#2185d0"/>
  </svg>
</template>
